import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let IconNews = (props) => {
  props = Object.assign({viewBox: '0 0 36 36'}, props);
  return (
    <SvgIcon {...props}>
      <g>
        <path className="st0"
              d="M23.4,10.9H12.6V12h10.9V10.9z M8.2,15.2v1.1h19.6v-1.1H8.2z M20.2,19.6h7.6v-1.1h-7.6V19.6z M20.2,22.9h7.6v-1.1h-7.6V22.9z M20.2,26.1h7.6V25h-7.6V26.1z M8.2,26.1h8.7v-7.6H8.2V26.1z M9.3,19.6h6.5V25H9.3V19.6z"/>
        <path className="st1" d="M32.2,29.8H3.8V6.2h28.5V29.8z M4.9,28.7h26.2V7.3H4.9V28.7z"/>
      </g>
    </SvgIcon>
  );
};

IconNews.displayName = 'IconNews';
IconNews.muiName = 'SvgIcon';

export default IconNews;



// WEBPACK FOOTER //
// ./src/components/Icons/IconNews.js